import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/our-past-work/viewer.tsx");
